import { toast as hotToast } from 'react-hot-toast';

// Enhanced toast with swipe-to-dismiss functionality
export const toast = {
  success: (message, options = {}) => {
    return hotToast.success(message, {
      ...options,
      className: 'swipeable-toast',
    });
  },
  
  error: (message, options = {}) => {
    return hotToast.error(message, {
      ...options,
      className: 'swipeable-toast',
    });
  },
  
  loading: (message, options = {}) => {
    return hotToast.loading(message, {
      ...options,
      className: 'swipeable-toast',
    });
  },
  
  custom: (jsx, options = {}) => {
    return hotToast.custom(jsx, {
      ...options,
      className: 'swipeable-toast',
    });
  },
  
  dismiss: hotToast.dismiss,
  remove: hotToast.remove,
};

// Initialize swipe-to-dismiss functionality
export const initializeToastSwipe = () => {
  let startX = 0;
  let currentX = 0;
  let isDragging = false;
  let toastElement = null;

  const handleTouchStart = (e) => {
    const toast = e.target.closest('[data-hot-toast]');
    if (!toast) return;
    
    toastElement = toast;
    startX = e.touches[0].clientX;
    isDragging = true;
    toast.classList.add('swiping');
  };

  const handleTouchMove = (e) => {
    if (!isDragging || !toastElement) return;
    
    e.preventDefault();
    currentX = e.touches[0].clientX;
    const deltaX = currentX - startX;
    
    // Apply transform with resistance
    const resistance = Math.abs(deltaX) > 100 ? 0.5 : 1;
    toastElement.style.transform = `translateX(${deltaX * resistance}px)`;
    toastElement.style.opacity = Math.max(0.3, 1 - Math.abs(deltaX) / 200);
  };

  const handleTouchEnd = (e) => {
    if (!isDragging || !toastElement) return;
    
    const deltaX = currentX - startX;
    const threshold = 80; // Minimum swipe distance to dismiss
    
    toastElement.classList.remove('swiping');
    
    if (Math.abs(deltaX) > threshold) {
      // Dismiss the toast
      const toastId = toastElement.getAttribute('data-hot-toast');
      if (deltaX > 0) {
        toastElement.classList.add('swiped-right');
      } else {
        toastElement.classList.add('swiped-left');
      }
      
      setTimeout(() => {
        hotToast.dismiss(toastId);
      }, 200);
    } else {
      // Snap back to original position
      toastElement.style.transform = 'translateX(0)';
      toastElement.style.opacity = '1';
    }
    
    isDragging = false;
    toastElement = null;
    startX = 0;
    currentX = 0;
  };

  const handleClick = (e) => {
    const toast = e.target.closest('[data-hot-toast]');
    if (!toast) return;
    
    // Dismiss on click/tap
    const toastId = toast.getAttribute('data-hot-toast');
    hotToast.dismiss(toastId);
  };

  // Add event listeners
  document.addEventListener('touchstart', handleTouchStart, { passive: false });
  document.addEventListener('touchmove', handleTouchMove, { passive: false });
  document.addEventListener('touchend', handleTouchEnd, { passive: true });
  document.addEventListener('click', handleClick, { passive: true });

  // Return cleanup function
  return () => {
    document.removeEventListener('touchstart', handleTouchStart);
    document.removeEventListener('touchmove', handleTouchMove);
    document.removeEventListener('touchend', handleTouchEnd);
    document.removeEventListener('click', handleClick);
  };
};

// Auto-initialize when module is imported
if (typeof window !== 'undefined') {
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeToastSwipe);
  } else {
    initializeToastSwipe();
  }
}

export default toast;
